import { render, staticRenderFns } from "./ProgramarComponent.vue?vue&type=template&id=fae415c6"
import script from "./ProgramarComponent.vue?vue&type=script&lang=js"
export * from "./ProgramarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports